import axios from "axios";
import { filter } from "lodash";

// Base URL configuration
// export const SOCKET_URL = "http://localhost:3369";
// const BASE_URL = "http://localhost:3369/api/app";
export const SOCKET_URL = "http://103.189.173.7:3369";
const BASE_URL = "http://103.189.173.7:3369/api/app";

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem("token");
      localStorage.removeItem("userProfile");

      // Public routes that should not redirect to sign-in
      const publicRoutes = [
        "/sign-in",
        "/",
        "/sign-up",
        "/forget-password",
        "/otp",
        "/reset-password",
        "/privecy-policy",
        "/privacy-policy",
        "/terms-and-condition",
        "/contact",
        "/faqandterms",
      ];

      // Only redirect if not already on a public route
      if (!publicRoutes.includes(window.location.pathname)) {
        window.location.href = "/sign-in";
      }
    }
    return Promise.reject(error);
  },
);

// Authentication API endpoints
export const authAPI = {
  // Sign up
  signup: async (userData) => {
    try {
      const response = await api.post("/sign-up", userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // firebase auth
  firebaseAuth: async (userData) => {
    try {
      const response = await api.post("/firebase-auth", userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Sign in
  signin: async (credentials) => {
    try {
      const response = await api.post("/login", credentials);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user profile
  getProfile: async () => {
    try {
      const response = await api.get(`/profile/get-profile`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get profile by id
  getProfileById: async (id) => {
    try {
      const response = await api.get(`/profile/get-profile?id=${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get trophies
  getTrophies: async (userId) => {
    try {
      const response = await api.get("/profile/trophies", {
        params: { userId },
      });
      return response;
    } catch (error) {
      throw error?.response?.data || error.message;
    }
  },

  // Get Activity Log
  getActivityLog: async (data) => {
    try {
      const response = await api.get(`/profile/activity-log`, {
        params: { userId: data.userId, type: data.type },
      });
      return response;
    } catch (error) {
      throw error?.response?.data || error.message;
    }
  },

  // update profile
  updateProfile: async (profileData, config = {}) => {
    try {
      const response = await api.post("/profile/update-profile", profileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        ...config,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get post
  getPosts: async (userId) => {
    try {
      const response = await api.get("/profile/posts", { params: { userId } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // create-post
  createPost: async (post) => {
    try {
      const response = await api.post("/profile/create-post", post, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Like on post
  likePost: async (postId) => {
    try {
      const response = await api.post(`/profile/posts/like/${postId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete Post
  deletePost: async (postId) => {
    try {
      const response = await api.delete(`/profile/posts/${postId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // create comment on post
  createComment: async (postId, content) => {
    try {
      const response = await api.post(`/profile/posts/comment/${postId}`, {
        content,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // follow user
  followUser: async (userId) => {
    try {
      const response = await api.post(`/profile/follow/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // unfollow user
  unfollowUser: async (userId) => {
    try {
      const response = await api.post(`/profile/unfollow/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user connections
  getConnections: async (query = { filter: "followers" }) => {
    try {
      const response = await api.get(`/profile/follow-list`, {
        params: { filter: query.filter, id: query.id },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Forget password
  forgetPassword: async (credentials) => {
    try {
      const response = await api.post("/forgot-password", credentials);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Generate Otp
  generateOtp: async (data) => {
    try {
      const response = await api.post("/genrate-otp", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Sent Otp on mobile number
  sentSMS: async (data) => {
    try {
      const response = await api.post(
        `http://smsbox.com/smsgateway/services/messaging.asmx/Http_SendSMS?username=valueandgrowth&password=VGA112233@&customerid=3441&sendertext=V G A&messagebody=Your OtP for Final Round is ${data.otp}&recipientnumbers=965${data.phone}&defdate=&isblink=false&isflash=false`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await api.post("/logout");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Otp verification
  verifyOtp: async (otpData) => {
    try {
      const response = await api.post("/verify-otp", otpData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // reset password
  resetPassword: async (passwordData) => {
    try {
      const response = await api.post("/reset-password", passwordData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // update or change password
  changePassword: async (data) => {
    try {
      const response = await api.post("/profile/change-password", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get notification
  getNotification: async (params) => {
    try {
      const response = await api.get("/profile/notifications", {
        params: params,
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Stores API endpoints
export const storesAPI = {
  // Get all stores
  getAllStores: async (params = {}) => {
    try {
      const response = await api.get("/ecommers/shops", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get store by ID
  getStoreById: async (storeId) => {
    try {
      const response = await api.get(`/ecommers/${storeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Request refund
  requestRefund: async (data) => {
    try {
      const response = await api.post(
        `ecommers/order/${data.orderId}/request-refund`,
        { items: data },
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new store
  createStore: async (storeData) => {
    try {
      const response = await api.post("/ecommers", storeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update store
  updateStore: async (storeId, storeData) => {
    try {
      const response = await api.put(`/ecommers/${storeId}`, storeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete store
  deleteStore: async (storeId) => {
    try {
      const response = await api.delete(`/ecommers/${storeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get stores by category
  getStoresByCategory: async (category, params = {}) => {
    try {
      const response = await api.get(`/ecommers/category/${category}`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Search stores
  searchStores: async (searchQuery, params = {}) => {
    try {
      const response = await api.get("/ecommers/search", {
        params: { q: searchQuery, ...params },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get featured stores
  getFeaturedStores: async () => {
    try {
      const response = await api.get("/ecommers/featured");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Place Orders
  placeOrder: async (orderData) => {
    try {
      const response = await api.post("/ecommers/order/place", {
        addressId: orderData.addressId,
        cartId: orderData.cartId,
        method: orderData.method,
        promoCode: orderData.promoCode,
        gatewayResponse: orderData.gatewayResponse,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get orders
  getOrders: async () => {
    try {
      const response = await api.get("/ecommers/orders");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    try {
      const response = await api.get(`/ecommers/orders/${orderId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add cart item
  addCartItem: async (itemId, quantity) => {
    try {
      const response = await api.post(`/ecommers/product/cart/${itemId}`, {
        quantity,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get cart items
  getCartItems: async () => {
    try {
      const response = await api.get("/ecommers/cart");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete cart item
  deleteCartItem: async (itemId, quantity) => {
    try {
      const response = await api.delete(`/ecommers/product/cart/${itemId}`, {
        data: { quantity },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get address
  getAddress: async () => {
    try {
      const response = await api.get("/address/get-saved-address");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete address
  deleteAddress: async (addressId) => {
    try {
      const response = await api.delete(`/address/delete-address/${addressId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add address
  addAddress: async (addressData) => {
    try {
      const response = await api.post("/address/add-address", addressData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Re-Order
  reOrder: async (orderId) => {
    try {
      const response = await api.post(`/ecommers/order/reorder/${orderId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Leave feedback
  leaveFeedback: async (feedbackData) => {
    try {
      const response = await api.post(
        `/ecommers/order/review/${feedbackData.orderId}`,
        feedbackData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Products API endpoints
export const productsAPI = {
  // Get products by vendor ID
  getVendorProducts: async (vendorId, params = {}) => {
    try {
      const response = await api.get(`/ecommers/vendor/products/${vendorId}`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get product by ID
  getProductById: async (productId) => {
    try {
      const response = await api.get(`/ecommers/product/${productId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all products
  getAllProducts: async (params = {}) => {
    try {
      const response = await api.get("/products", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Search products
  searchProducts: async (searchQuery, params = {}) => {
    try {
      const response = await api.get("/products/search", {
        params: { q: searchQuery, ...params },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Liked Product
  likeProduct: async (productId) => {
    try {
      const response = await api.post(`/ecommers/product/like/${productId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get featured products
  getFeaturedProducts: async (params = {}) => {
    try {
      const response = await api.get("/ecommers/products/featured", {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Revoke like from the product
  revokeLike: async (productId) => {
    try {
      const response = await api.delete(`/ecommers/product/like/${productId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Auctions API endpoints
export const auctionsAPI = {
  // Get all auctions
  getAllAuctions: async (params = {}) => {
    try {
      const response = await api.get("/auction/fetch-auctions", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get auction by ID
  getAuctionById: async (auctionId) => {
    try {
      const response = await api.get(`/auction/details/${auctionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new auction
  createAuction: async (auctionData) => {
    try {
      const formData = new FormData();

      // Add text fields
      Object.keys(auctionData).forEach((key) => {
        if (key !== "images" && auctionData[key] !== undefined) {
          formData.append(key, auctionData[key]);
        }
      });

      // Add images
      if (auctionData.images && Array.isArray(auctionData.images)) {
        auctionData.images.forEach((image) => {
          formData.append("image", image);
        });
      }

      const response = await api.post("/auction/create-auction", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update auction
  updateAuction: async (auctionId, auctionData) => {
    try {
      const response = await api.put(`/auction/${auctionId}`, auctionData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete auction
  deleteAuction: async (auctionId) => {
    try {
      const response = await api.delete(`/auction/${auctionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Place a bid
  placeBid: async (auctionId, bidData) => {
    try {
      const response = await api.post(
        `/auction/${auctionId}/place-bid`,
        bidData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get auction bids
  getAuctionBids: async (auctionId, params = {}) => {
    try {
      const response = await api.get(`/auction/bids/?id=${auctionId}`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Search auctions
  searchAuctions: async (searchQuery, params = {}) => {
    try {
      const response = await api.get("/auction/search", {
        params: { q: searchQuery, ...params },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user's auctions
  getUserAuctions: async (userId, params = {}) => {
    try {
      const response = await api.get(`/auction/user/${userId}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user's bids
  getUserBids: async (params = {}) => {
    try {
      const response = await api.get(`/auction/bids`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Wallet API endpoints
export const walletAPI = {
  // Get wallet summary
  getWalletSummary: async () => {
    try {
      const response = await api.get("/wallet/summary");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get wallet transactions
  getWalletTransactions: async (params) => {
    try {
      const response = await api.get("/wallet/transactions", {
        params: params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get recent recipients
  getRecentRecipients: async () => {
    try {
      const response = await api.get("/wallet/recent-recipients");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get bank details
  getBankDetails: async () => {
    try {
      const response = await api.get("/wallet/bank-details");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // withdraw amount
  withdrawAmount: async (data) => {
    try {
      const response = await api.post("/wallet/withdraw", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // delete bank detail
  deleteBankDetails: async (bankId) => {
    try {
      const response = await api.delete(`/wallet/bank-details/${bankId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // make primary bank
  makePrimaryBank: async (data) => {
    try {
      const response = await api.post(`/wallet/bank-details/primary`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get tokens bundles (package)
  getTokenBundles: async () => {
    try {
      const response = await api.get("/wallet/token-bundles");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Pay payment for get tokens
  addPayIn: async (data) => {
    try {
      const response = await api.post("/wallet/payin", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // send token
  sendToken: async (data) => {
    try {
      const response = await api.post("/wallet/send-tokens", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // add bank details
  addBankDetails: async (data) => {
    try {
      const response = await api.post("/wallet/bank-details", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Reports API endpoints
export const reportAPI = {
  // Create a new report for any entity (e.g. livestream, comment, forum, etc.)
  createReport: async (data) => {
    try {
      // Backend createReport expects: entityType, entityId, reason, severity (optional)
      const response = await api.post("/reports/create-report", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Podcast API endpoints
export const podcastAPI = {
  // Get all podcasts
  loadPodCasts: async (params = {}) => {
    try {
      const response = await api.get("/podcast/get-podcasts", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single podcast
  loadPostCastById: async (podcastId) => {
    try {
      const response = await api.get(`/podcast/${podcastId}/podcast`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // get comment and comments details for single podcast
  loadPodcastComments: async (podcastId) => {
    try {
      const response = await api.get(`/podcast/${podcastId}/comments`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // write a comment on podcast
  writePodcastComment: async (podcastId, commentData) => {
    try {
      const response = await api.post(`/podcast/${podcastId}/comment`, {
        comment: commentData,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // add like
  addPodcastLike: async (podcastId) => {
    try {
      const response = await api.post(`/podcast/${podcastId}/like`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // remove like
  removePodcastLike: async (podcastId) => {
    try {
      const response = await api.delete(`/podcast/${podcastId}/like`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export const settingsAPI = {
  cmsManagement: async (contentType, lng) => {
    try {
      const response = await api.get(
        `/settings/cms-pages?page=${contentType}&language=${lng}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  activeDevices: async () => {
    try {
      const response = await api.get(`/settings/devices`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  revokeDevice: async (deviceId, single = true) => {
    try {
      const url = single
        ? "/settings/devices/revoke"
        : "/settings/devices/revoke-all-others";

      const payload = single ? { device_id: deviceId } : {};

      const response = await api.post(url, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  feedbacks: async (queryParams) => {
    try {
      const response = await api.get(
        `/settings/feedback?page=${queryParams?.page}&limit=${queryParams?.limit}&status=${queryParams?.status}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  submitFeedback: async (feedbackData) => {
    try {
      const formData = new FormData();
      formData.append("category", feedbackData.category);
      formData.append("subject", feedbackData.subject);
      formData.append("description", feedbackData.description);
      formData.append("acknowledgement", feedbackData.acknowledgement);
      // Append image if it exists
      if (feedbackData.image) {
        formData.append("image", feedbackData.image);
      }
      const response = await api.post("/settings/feedback", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Get surveys ----------
  getSurveys: async () => {
    try {
      const response = await api.get("/settings/surveys");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // --------- Vote Survey ---------
  voteSurvey: async (data) => {
    try {
      const response = await api.post(`/settings/surveys/vote`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export const forumsAPI = {
  getForums: async (params = {}) => {
    try {
      const response = await api.get("/forums/get-open-forums", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getForumThreads: async (forumId, query = {}) => {
    if (!forumId) throw new Error("Forum ID is required");
    try {
      const response = await api.get(`/forums/forums/${forumId}/threads`, {
        params: query,
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  createThread: async (threadData) => {
    try {
      const response = await api.post("/forums/topics", threadData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getThreadDetails: async (threadId) => {
    if (!threadId) throw new Error("Thread ID is required");
    try {
      const response = await api.get(`/forums/threads/${threadId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Reply on thread
  replyOnThread: async (threadId, formData, config = {}) => {
    if (!threadId) throw new Error("Thread ID is required");
    try {
      const response = await api.post(
        `/forums/topics/comments/${threadId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          ...config,
        },
      );
      return response.data; // <-- This is what your component needs
    } catch (error) {
      console.error("❌ replyOnThread failed:", error);
      throw error.response?.data || { success: false, message: error.message };
    }
  },

  // ✅ Reply on comment
  replyOnComment: async (threadId, commentId, formData, config = {}) => {
    if (!threadId || !commentId)
      throw new Error("Thread ID and Comment ID are required");
    try {
      const response = await api.post(
        `/forums/topics/comments/${threadId}/replies/${commentId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          ...config,
        },
      );
      return response.data;
    } catch (error) {
      console.error("❌ replyOnComment failed:", error);
      throw error.response?.data || { success: false, message: error.message };
    }
  },

  submitVote: async (threadId, body, config = {}) => {
    if (!threadId || !body?.action)
      throw new Error("Thread ID and action are required");

    try {
      const response = await api.post(`/forums/topics/vote/${threadId}`, body, {
        headers: { "Content-Type": "application/json" },
        ...config,
      });
      return response.data; // { success: true, data: ... }
    } catch (error) {
      console.error("❌ submitVote failed:", error);
      throw error.response?.data || { success: false, message: error.message };
    }
  },

  // Report Forum
  reportForum: async (threadId, data) => {
    try {
      const response = await api.post(`/forums/topics/report/${threadId}`, {
        message: data,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export const kycAPI = {
  submitKYC: async (formData) => {
    try {
      const response = await api.post("/profile/kyc-request", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  fetchKYC: async () => {
    try {
      const response = await api.get("/profile/kyc-details"); // Adjust endpoint if different
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Tournaments API
export const tournamentAPI = {
  // ------- Load Tournaments --------
  loadTournaments: async (params = {}) => {
    try {
      const response = await api.get("/tournaments/list", { params });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ------- Register Tournaments ------
  registerTournament: async (tournamentData) => {
    try {
      const response = await api.post("/tournaments/register", {
        tournamentId: tournamentData.tournamentId,
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Update Stream Link -----------
  updateStreamLink: async (data) => {
    try {
      const response = await api.put(
        `/tournaments/participants/update-stream-link/${data.tournamentId}`,
        data,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ------- Create Private Tournaments ------
  createPrivateTournament: async (data) => {
    try {
      const response = await api.post(`/tournaments/private/create`, data);
      return response;
    } catch (error) {
      throw error.response.data || error.message;
    }
  },

  // ------ Get Tournament Team List ------
  loadTournamentList: async (query) => {
    try {
      const response = await api.get(`/tournaments/teams`, { params: query });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Get Tournament -----------
  loadTournament: async (tournamentId) => {
    try {
      const response = await api.get(`/tournaments/tournament`, {
        params: { tournamentId },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // --------- Create Team ----------
  joinTeam: async (teamData) => {
    try {
      const response = await api.post("/tournaments/join-team", teamData);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Join With Team ----------
  joinWithTeam: async (teamData) => {
    try {
      const response = await api.post(
        "/tournaments/register-with-team",
        teamData,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // --------- Get games --------------
  loadGames: async (params = {}) => {
    try {
      const response = await api.get("/tournaments/games-by-mode", { params });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // -------- Get games list ----------
  gamesList: async (status) => {
    try {
      const response = await api.get(`/tournaments/gamelist`, {
        params: status,
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Get season based on game ---------
  seasonsList: async (id) => {
    try {
      const response = await api.get(`/tournaments/seasons/${id}`);
      return response;
    } catch (error) {
      throw error.response.data || error.message;
    }
  },

  // --------- Geners List --------------
  genersList: async (status) => {
    try {
      const response = await api.get(`/tournaments/geners`, { params: status });
      return response;
    } catch (error) {
      throw error.response.data || error.message;
    }
  },

  // ------- Get player in tournaments ------
  loadPlayerInTournament: async (params = {}) => {
    try {
      const response = await api.get(`/tournaments/private/search-users`, {
        params,
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // -------- View Brackets ------------
  viewBrackets: async (tournamentId) => {
    try {
      const params = {
        tournamentId,
      };
      const response = await api.get(`/tournaments/bracket`, { params });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // -------- Teams ------------
  loadTeams: async (tournamentId) => {
    try {
      const response = await api.get(`/tournaments/teams`, {
        params: { tournamentId },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // ------- Switch Players ---------
  switchPlayers: async (data) => {
    try {
      const response = await api.post(`/tournaments/team/switch-player`, data);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // ------- Update Team -----------
  updateTeam: async (data) => {
    try {
      const response = await api.post(`/tournaments/team/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ------- Generate Bracket --------
  generateBracket: async (tournamentId) => {
    try {
      const response = await api.post(
        `/tournaments/bracket/generate/${tournamentId}`,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  //------- Update Score ------------
  updateTeamScore: async (data) => {
    try {
      const response = await api.post(
        `/tournaments/${data.tournamentId}/matches/${data.matchId}/score`,
        data,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Progress to next round --------
  progressToNextRound: async (tournamentId) => {
    try {
      const response = await api.post(
        `/tournaments/progress-round/${tournamentId}`,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Final round end -----------
  endFinalRound: async (tournamentId) => {
    try {
      const response = await api.post(
        `/tournaments/distribute-trophies/${tournamentId}`,
      );
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Leader Board API
export const leaderboardAPI = {
  // Load Global Leaderboard
  loadLeaderboard: async () => {
    try {
      const response = await api.get(`/leaderboards/global`);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Load Global Game Leaderboard
  loadGameLeaderboard: async () => {
    try {
      const response = await api.get(`/leaderboards/game`);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Load Leaderboard Profile
  leaderboardProfile: async () => {
    try {
      const response = await api.get(`/leaderboards/profile`);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Load Leaderboard Profile
  gameLeaderboard: async (gameId) => {
    try {
      const response = await api.get(`/leaderboards/game/${gameId}`);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

// Subscription API
export const subscriptionAPI = {
  // ------ Get Subscription Plans --------
  loadSubscriptionPlans: async () => {
    try {
      const response = await api.get("/subscription/plans");
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ---------- Get My Plan ----------
  getMyPlan: async () => {
    try {
      const response = await api.get("/subscription/me");
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ------------- Buy Plan ---------------
  purchasePlan: async (data) => {
    try {
      const response = await api.post("/subscription/buy", data);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ----------- Cancel Plan -----------
  cancelPlan: async () => {
    try {
      const response = await api.post("/subscription/cancel");
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default api;
